<template>
  <div>{{ $options.name }}</div>
</template>

<script>

export default {
  name: "Admin-Policy-Create",
  path: "create",
  mounted() {
   this.$spark.$breadcrumbs(this.$options);
  }
};
</script>
